// extracted by mini-css-extract-plugin
export default {"light":"styles_light__YnSXF","connectModal":"styles_connectModal__Cow4P","connectButton":"styles_connectButton__9HYLw"};